import React, { MouseEventHandler, useCallback, useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { classNames } from 'primereact/utils';
import { Button } from 'primereact/button';
import { Avatar } from 'primereact/avatar';
import { OverlayPanel } from 'primereact/overlaypanel';
import { InputSwitch } from 'primereact/inputswitch';
import { Slider } from 'primereact/slider';
import { Menu } from 'primereact/menu';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useIsAuthenticated, useMsal } from "@azure/msal-react";
import { msalInstance } from './service/msal';

interface AppTopbarProps {
    layoutColorMode: string
    onColorModeChange: any
    onToggleMenuClick: MouseEventHandler<HTMLButtonElement>
    onMobileTopbarMenuClick: MouseEventHandler<HTMLButtonElement>
    onMobileSubTopbarMenuClick: MouseEventHandler<HTMLButtonElement>
    mobileTopbarMenuActive: boolean
}

export const AppTopbar = (props: AppTopbarProps) => {
    const op = useRef<any>(null);
    const [theme, setTheme] = useState('lara-light-blue');
    const [themeToggle, setThemeToggle] = useState(false);
    //const [profilePhotoUrl, setProfilePhoto] = useState('');
    const [userInitials, setUserInitials] = useState('');
    const [scale, setScale] = useState<number>(14);

    useEffect(() => {
        document.documentElement.style.fontSize = scale + 'px';
    }, [scale])

    const onThemeToggle = (e: any) => {
        setThemeToggle(e.value);
        changeTheme(e, e.value === false ? 'lara-light-blue' : 'lara-dark-blue', e.value === false ? 'light' : 'dark');
    }

    const changeTheme = (e: React.MouseEvent<HTMLButtonElement>, theme: string, scheme: string) => {
        props.onColorModeChange(scheme);
        setTheme(theme);
    }

    const replaceLink = useCallback((linkElement: HTMLElement, href: string, callback?: any) => {
        if (isIE()) {
            linkElement.setAttribute('href', href);

            if (callback) {
                callback();
            }
        }
        else {
            const id = linkElement.getAttribute('id');
            const cloneLinkElement = linkElement.cloneNode(true) as Element;

            cloneLinkElement.setAttribute('href', href);
            cloneLinkElement.setAttribute('id', id + '-clone');

            linkElement.parentNode?.insertBefore(cloneLinkElement, linkElement.nextSibling);

            cloneLinkElement.addEventListener('load', () => {
                linkElement.remove();
                cloneLinkElement.setAttribute('id', id ? id : 'unknown');

                if (callback) {
                    callback();
                }
            });
        }
    },[])

    useEffect(() => {
        let themeElement = document.getElementById('theme-link');
        const themeHref = '/assets/themes/' + theme + '/theme.css';
        replaceLink(themeElement as HTMLElement, themeHref);
    },[theme,replaceLink])

    const isIE = () => {
        return /(MSIE|Trident\/|Edge\/)/i.test(window.navigator.userAgent)
    }

    // async function getProfilePhoto(accessToken: any) {
    //     if (!accessToken) {
    //         const account = msalInstance.getActiveAccount();
    //         if (!account) {
    //             throw Error("No active account! Verify a user has been signed in and setActiveAccount has been called.");
    //         } else {
    //             if (account.name != null) {
    //                 setUserInitials(account.name.split(" ").map(function(c) { return c[0] }).join(''))
    //             }
    //         }
        
    //         const response = await msalInstance.acquireTokenSilent({
    //             ...loginRequest,
    //             account: account                
    //         });

    //         accessToken = response.accessToken;
    //     }
    
    //     const headers = new Headers();
    //     const bearer = `Bearer ${accessToken}`;
    
    //     headers.append("Authorization", bearer);
    //     headers.append("Content-Type", "image/jpeg");
        
    //     const options = {
    //         method: "GET",
    //         headers: headers
    //     };
    
    //     const profilePhoto = document.getElementById("profilePhoto");
    //     const profileUnavailable = document.getElementById("profileUnavailable");

    //     fetch(graphConfig.graphMePhotoEndpoint, options)
    //         .then(response => {
    //             if (response != null && response.ok) {response.blob().then((data) => {
    //                 if (data !== null) {
    //                   const url = window.URL = window.URL || window.webkitURL;
    //                   const blobUrl = url.createObjectURL(data);
    //                   //setProfilePhoto(blobUrl);
                      
    //                   if (profilePhoto != null) {
    //                     profilePhoto.setAttribute("src", blobUrl);
    //                     profilePhoto.style.display = 'block';
    //                   }

    //                   if (profileUnavailable != null) {
    //                     profileUnavailable.style.display = 'none';
    //                   }

    //                   return blobUrl;
    //                 }
    //               });
    //             } else {
    //                 if (profilePhoto != null) {
    //                     profilePhoto.style.display = 'none';
    //                 }

    //                 if (profileUnavailable != null) {
    //                     profileUnavailable.style.display = 'block';
    //                 }
    //             }
    //         })
    //         .catch(error => console.log(error));
    // }

    const LoginAuthentication = () => {
        const { instance } = useMsal();
        const isAuthenticated = useIsAuthenticated();
        const menu = useRef<any>(null);

        const handleLogin = () => {
            instance.handleRedirectPromise().then(() => {
                const account = instance.getActiveAccount();
                if(!account){
                    instance.loginRedirect().catch(e => console.error(e));
                }
            }).catch(err => {
                console.log(err);
            });            
        }
    
        // const footer = (
        //     <div>
        //         <Button label="Close" icon="pi pi-times" className="p-button-text" />
        //     </div>
        // );

        // const showUserProfile = () => {
        //     return (
        //         <>
        //         <Dialog header="Header" style={{ width: '50vw' }} footer={footer}>
        //             <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
        //             Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
        //             Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
        //             cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
        //         </Dialog>
        //         </>
        //     );
        // }

        const loginItems = [
            {
                label: 'Login',
                icon: 'pi pi-lock-open',
                command: () => {
                    handleLogin();
                }
            }
        ];
    
        const logoutItems = [
            {
                label: 'Logout',
                icon: 'pi pi-lock',
                command: () => {
                    msalInstance.logoutRedirect()
                }
            }
        ];
    
        const ShowLogin = () => {
            return (
                <>
                    <Menu model={loginItems} popup ref={menu} id="popup_menu" className="overlay-menu"/>
                    <button className="p-link layout-topbar-button" onClick={(event) => menu?.current?.toggle(event)} aria-controls="popup_menu" aria-haspopup>
                        <i className="pi pi-user"/>
                        <span>User</span>
                    </button>
                </>
            );
        }
    
        const ShowLogout = () => {
            // useEffect(() => {
            //     getProfilePhoto(null);
            // }, [msalInstance]);
            
            useEffect(() => {
                if (isAuthenticated){
                    const account = msalInstance.getActiveAccount();

                    if (account?.name != null) {
                        setUserInitials(account.name.split(" ").map(function(c) { return c[0] }).join(''))
                    }
                }
            }, []);
            
            return (
                <>
                    <Menu model={logoutItems} popup ref={menu} id="popup_menu" className="overlay-menu"/>
                    <Button className="layout-menu-button p-link p-button-text p-button-rounded p-button-secondary" onClick={(event) => menu?.current?.toggle(event)} aria-controls="popup_menu" aria-haspopup>
                        {/* <i id="profileUnavailable" className="pi pi-user"/> */}
                        {/* <img id="profilePhoto" src={profilePhoto}/> */}
                        {<Avatar label={userInitials} size="large" shape="circle" />}
                        {/* <div id="profileUnavailable" className="p-avatar p-component p-avatar-circle p-avatar-lg mr-2"><span className="p-avatar-text">{userInitials}</span></div> */}
                        {/* <img id="profilePhoto" /> */}
                        {/* <Person personQuery="me"></Person> */}
                    </Button>
                    
                </>
            );
        }
    
        return (
            <>
                <AuthenticatedTemplate>
                    <ShowLogout />
                </AuthenticatedTemplate>
                <UnauthenticatedTemplate>
                    <ShowLogin/>
                </UnauthenticatedTemplate>
            </>
        );
    };

    return (
        <div className="layout-topbar">
            <Link to="/" className="layout-topbar-logo">
                <img src={props.layoutColorMode === 'light' ? '/assets/layout/images/varsity-logo-light.svg' : '/assets/layout/images/varsity-logo-dark.svg'} alt="logo"/>
                <p className="text-xl font-bold">Bill of Materials Editor</p>
            </Link>

            <AuthenticatedTemplate>
                <button type="button" className="p-link layout-menu-button layout-topbar-button" title="Hide Menu" onClick={props.onToggleMenuClick}>
                    <i className="pi pi-bars" />
                </button>
            </AuthenticatedTemplate>

            <button type="button" className="p-link layout-topbar-menu-button layout-topbar-button" onClick={props.onMobileTopbarMenuClick}>
                <i className="pi pi-ellipsis-v" />
            </button>

            <ul className={classNames("layout-topbar-menu lg:flex origin-top", {'layout-topbar-menu-mobile-active': props.mobileTopbarMenuActive })}>
                <li>
                    <Button className="p-link layout-topbar-button" title="Settings" onClick={(e) => op.current.toggle(e)}>
                        <i className="pi pi-cog"/>
                    </Button>
                    <OverlayPanel ref={op} className="overlay_panel" >
                        <div className="mb-3">
                            <p className="text-center font-bold">Scale</p>
                            <Slider value={scale} onChange={(e) => setScale(e.value as number)} min={8} max={16}/>
                        </div>
                        <div className="color-scheme">
                            <p className="text-center font-bold">Color Scheme</p>
                            <div className="grid">
                                <div className="col text-center mt-1">
                                    <i className="pi pi-sun text-orange-500"/>
                                </div>
                                <div className="col text-center">
                                    <InputSwitch checked={themeToggle} onChange={(e) => onThemeToggle(e)} />
                                </div>
                                <div className="col text-center mt-1">
                                    <i className="pi pi-moon text-blue-700"/>
                                </div>
                            </div>
                        </div>
                    </OverlayPanel>
                </li>
                <li>
                    <LoginAuthentication />
                </li>
            </ul>
        </div>
    );
}